<sh-comments [comments]="comments" [correspondingDay]="correspondingDay"
  [correspondingEmployeeId]="correspondingEmployeeId" [commentType]="commentType" (closeEvent)="closeCommentTooltip()"
  (commentsChanged)="updateCommentIndicator($event)"></sh-comments>